import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, DestroyRef, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute } from '@angular/router';
import { FeatureFlagService } from '@core/feature';
import { BonusHistoryList } from '@my-account/const';
import { BonusHistoryService } from '@my-account/feature';
import { SdvorCustomPaginationComponent } from '@sdvor/shared/ui';
import { CustomPaginationModel } from '@shared/models';
import { BonusAvailable } from '@user/const';
import { CurrentProfileService } from '@user/feature';
import { Observable } from 'rxjs';
import { distinctUntilChanged, map } from 'rxjs/operators';
import { BonusHistoryBlockComponent } from './bonus-history-block/bonus-history-block.component';
import { BonusStatusBlockComponent } from './bonus-status-block/bonus-status-block.component';

@Component({
  selector: 'sd-bonus-history',
  templateUrl: './bonus-history.component.html',
  styleUrls: ['./bonus-history.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [BonusStatusBlockComponent, AsyncPipe, SdvorCustomPaginationComponent, BonusHistoryBlockComponent],
})
export class BonusHistoryComponent implements OnInit {
  bonusBalance$: Observable<BonusAvailable>;
  bonusHistory$: Observable<BonusHistoryList[] | undefined>;
  paginations$: Observable<CustomPaginationModel | undefined>;
  enabledBonusStatus$: Observable<boolean>;

  constructor(
    private currentProfileService: CurrentProfileService,
    private bonusHistoryService: BonusHistoryService,
    private activatedRoute: ActivatedRoute,
    private destroyRef: DestroyRef,
    private featureFlagService: FeatureFlagService,
  ) {}

  ngOnInit(): void {
    this.bonusBalance$ = this.currentProfileService.get().pipe(map((user) => user.bonusBalance));
    this.bonusHistory$ = this.bonusHistoryService.getBonusHistoryBonuses();
    this.paginations$ = this.bonusHistoryService.getBonusHistoryPagination();

    this.activatedRoute.queryParams.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((params) => {
      this.bonusHistoryService.loadBonusHistory({ currentPage: params.page || 0 });
    });

    this.enabledBonusStatus$ = this.featureFlagService.isEnabled('isBonusStatusEnabled').pipe(distinctUntilChanged());
  }
}
